import { Modal } from "@/components";
import ContentModalFlex from "./ContentModalFlex";
import { ProductProps, PackagesTypesProps, TaxSubstitutionProps, PriceProductProps } from "@/types";

interface Props {
  packQty: number;
  product: ProductProps;
  price: PriceProductProps;
  isOpenedModal: boolean;
  pack: PackagesTypesProps | null;
  substTrib: TaxSubstitutionProps[];
  openModal: (val: boolean) => void;
  setPackQuantity: (val: number) => void;
  setPackage: (val: PackagesTypesProps) => void;
  hasStock?: any;
}

const ModalFlexDiscount = ({
  pack,
  product,
  price,
  substTrib,
  isOpenedModal,
  packQty,
  hasStock,
  openModal,
  setPackage,
  setPackQuantity,
}: Props) => {
  return (
    <Modal
      fullHeight
      id="flex-discount"
      isOpen={isOpenedModal}
      closeModal={openModal}
    >
      {isOpenedModal && (
        <ContentModalFlex
          pack={pack || 'PK'}
          packQty={packQty}
          price={price}
          setPackQuantity={setPackQuantity}
          product={product}
          substTrib={substTrib}
          openModal={openModal}
          setPackage={setPackage}
          isOpenedModal={true}
          hasStock={hasStock}
        />
      )}
    </Modal>
  );
};

export default ModalFlexDiscount;
